import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=f0b45b62"
import script from "./Quick.vue?vue&type=script&lang=js"
export * from "./Quick.vue?vue&type=script&lang=js"
import style0 from "./Quick.vue?vue&type=style&index=0&id=f0b45b62&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports